import { Component } from '@theme/component';

class VrDesktopSidebar extends Component {
  #controller;
  #observer;
  #header;
  #details;
  #wasOpen = false;
  #blockedPeers = new Map();
  #desktop = window.matchMedia('(min-width: 750px)');

  connectedCallback() {
    super.connectedCallback();
    this.#bind();
  }

  updatedCallback() {
    super.updatedCallback();
    this.#bind();
  }

  disconnectedCallback() {
    this.#cleanup();
    super.disconnectedCallback();
  }

  #bind() {
    this.#cleanup();
    this.#header = this.closest('#header-component');
    this.#details = this.#header?.querySelector('#Details-menu-drawer-container');
    if (!(this.#header instanceof HTMLElement) || !(this.#details instanceof HTMLDetailsElement)) return;

    this.#controller = new AbortController();
    const options = { signal: this.#controller.signal };
    this.#details.addEventListener('toggle', this.#sync, options);
    this.#details.querySelector('summary')?.addEventListener('click', this.#sync, { ...options, capture: true });
    window.addEventListener('resize', this.#sync, options);
    this.#observer = new ResizeObserver(this.#sync);
    this.#observer.observe(this.#header);
    this.#sync();
  }

  #sync = () => {
    if (!this.#header || !this.#details) return;
    const open = this.#desktop.matches && this.#details.open;

    if (this.#desktop.matches) {
      const bottom = Math.max(0, this.#header.getBoundingClientRect().bottom);
      this.#header.style.setProperty('--vr-sidebar-top', `${bottom}px`);
    }

    if (open) {
      const peers = this.#header.querySelectorAll('.header__column--center, .header__column--right');
      for (const peer of peers) {
        if (!(peer instanceof HTMLElement)) continue;
        if (!this.#blockedPeers.has(peer)) this.#blockedPeers.set(peer, peer.inert);
        peer.inert = true;
      }
    } else {
      this.#restorePeers();
      if (this.#wasOpen && this.#desktop.matches) {
        this.#details.querySelector('summary')?.focus({ preventScroll: true });
      }
    }
    this.#wasOpen = open;
  };

  #restorePeers() {
    for (const [peer, wasInert] of this.#blockedPeers) peer.inert = wasInert;
    this.#blockedPeers.clear();
  }

  #cleanup() {
    this.#controller?.abort();
    this.#observer?.disconnect();
    this.#restorePeers();
    this.#wasOpen = false;
  }
}

if (!customElements.get('vr-desktop-sidebar')) {
  customElements.define('vr-desktop-sidebar', VrDesktopSidebar);
}
